// extracted by mini-css-extract-plugin
export default {"container":"IOActiveOffersPage-module__container--wGXqQ","scrollable":"IOActiveOffersPage-module__scrollable--Yevxw","primary":"IOActiveOffersPage-module__primary---q++f"};